<template>
  <v-tooltip top>
    <template v-slot:activator="{ on: tooltipListeners }">
      <div v-on="tooltipListeners">
        <v-icon class="mr-1">eva-checkmark-circle-2</v-icon>
        <span>Salvo {{ lastSaveTime }}.</span>
      </div>
    </template>
    Salvo em {{ formattedSavedAt }}.
  </v-tooltip>
</template>

<script>
export default {
  name: "SuccessSaveMessage",
  data() {
    return {
      lastSaveTime: "recentemente",
      lastSaveInterval: null,
    };
  },
  props: {
    savedAt: {
      type: String,
      required: false,
      default: null,
    },
    updateTimeMs: {
      type: Number,
      required: false,
      default: 5000,
    },
  },
  created() {
    this.startLastSaveInterval();
  },
  beforeDestroy() {
    clearInterval(this.lastSaveInterval);
  },
  computed: {
    momentSavedAt() {
      return this.$moment(this.savedAt);
    },
    formattedSavedAt() {
      if (!this.savedAt) return;

      return this.momentSavedAt.format("DD/MM/YY à\\s HH:mm");
    },
  },
  methods: {
    startLastSaveInterval() {
      this.updateLastSaveTime();

      this.lastSaveInterval = setInterval(() => {
        this.updateLastSaveTime();
      }, this.updateTimeMs);
    },
    updateLastSaveTime() {
      if (!this.savedAt) return;

      this.lastSaveTime = this.momentSavedAt.fromNow();
    },
  },
};
</script>

<style></style>
